// PHA-480 + PHA-573: tab-index constants for PatientDetail.
// Lifted into its own tiny file to break the circular import that arose
// once PatientDetail started importing the SmartHub/ai components (which
// themselves need to know the numeric tab index for citation deep-links).
//
// Both PatientDetail.tsx and any deep-link source (AckDrawer.tsx,
// CitationLink.tsx, ...) should import from HERE, not from PatientDetail.
//
// PatientDetail.tsx re-exports the same constant for backward compatibility
// with existing call sites — leave that re-export in place even when this
// file is the source of truth.
export const PATIENT_DETAIL_TAB_INDEX = {
  PROBLEMS: 0,
  MEDICATIONS: 1,
  CARE_PLANS: 2,
  // PHA-795: "Voice of the patient" placed between Care Plans and Surveys.
  // When VoP is disabled for an org the Tab is mounted with display:none so
  // all higher indices remain stable regardless of gate status.
  VOICE_OF_PATIENT: 3,
  SURVEYS: 4,
  PATIENT_OUTREACH: 5,
  EVENT_LOG: 6,
  ANSWERS: 7,
  DEVICE_READINGS: 8,
  AI_INSIGHTS: 9,
} as const;
